import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  FLOW_GATEWAY,
  WHHttpParams,
  WHWorkObjectDOM,
  WHWorkObjectTypeENUM,
  initHttpParams,
} from '@workheld/workheld-shared-lib';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
export enum ENDPOINTS_ENUM {
  PROJECT = '/projects/preview',
  CASE = '/cases/preview',
  STANDING_ORDER = '/standingorders/preview',
}

export const ENDPOINT = {
  WORK_OBJECTS(id: string, cacheKey: string): string {
    return `/workObjects/${id}/${cacheKey}`;
  },
  PROJECT(): string {
    return ENDPOINTS_ENUM.PROJECT;
  },
  CASE(): string {
    return ENDPOINTS_ENUM.CASE;
  },
  STANDING_ORDER(): string {
    return ENDPOINTS_ENUM.STANDING_ORDER;
  },
};

export class WorkObjectNewDOM {
  content: WHWorkObjectDOM[];
  empty: boolean;
  first: boolean;
  last: boolean;
  number: number;
  numberOfElements: number;
  size: number;
  sort: Array<any>;
  totalElements: number;
  totalPages: number;
}

@Injectable({
  providedIn: 'root',
})
export class WorkObjectsDataService {
  private readonly httpClient = inject(HttpClient);
  private readonly cacheKey = new Date().toISOString();

  getWorkObjects(
    params: WHHttpParams,
    type: WHWorkObjectTypeENUM,
  ): Observable<any> {
    let woType = WHWorkObjectTypeENUM[type];

    const httpParams: HttpParams = initHttpParams(params);
    return this.httpClient.get<any>(
      `${environment.apiUrl + FLOW_GATEWAY + ENDPOINTS_ENUM[woType]}`,
      { params: httpParams },
    );
  }

  getWorkObject(id: string) {
    return this.httpClient.get<any>(
      `${environment.apiUrl + FLOW_GATEWAY + ENDPOINT.WORK_OBJECTS(id, this.cacheKey)}`,
    );
  }
}
